import { STORAGE_KEY, SAVED_PROGRESS_EXPIRY_DAYS } from './constants';

export function saveProgress(data) {
  const progress = {
    ...data,
    savedAt: new Date().toISOString(),
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(progress));
}

export function loadSavedProgress(instrumentVersion) {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (!saved) return null;

  try {
    const progress = JSON.parse(saved);

    if (progress.version !== instrumentVersion) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }

    const savedDate = new Date(progress.savedAt);
    const daysSinceSave = (Date.now() - savedDate.getTime()) / (1000 * 60 * 60 * 24);
    if (daysSinceSave > SAVED_PROGRESS_EXPIRY_DAYS) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }

    return progress;
  } catch {
    localStorage.removeItem(STORAGE_KEY);
    return null;
  }
}

export function clearSavedProgress() {
  localStorage.removeItem(STORAGE_KEY);
}
